import { Column } from "../../../common/components/CommonBaseComponents";
import PGCodeContainer from "../components/PGCodeContainer";

function PGCodeTabContent({ storeId }) {
    return (
        <Column padding={"14px 0"} alignItem={"flex-start"} width={"100%"} maxWidth={"830px"}>
            <PGCodeContainer storeId={storeId} />
        </Column>
    );
}

export default PGCodeTabContent;
